<div class="home-container" *ngIf="windowsStarted">
    <div class="app-icons">
      <div *ngFor="let app of apps" class="app-icon" (click)="openWindow(app.component)">
        <span><img [src]="app.icon" alt="{{ app.name }}"></span><br>
        <span>{{ app.name }}</span>
      </div>
    </div>

    <app-window *ngFor="let window of openWindows" [title]="window.title" [component]="window.component" 
        (close)="closeWindow(window.component)"></app-window>

    <div class="taskbar">
      <!-- Start Button -->
      <div class="start-button" (click)="resetWindows()">
        <img src="assets/icons/StartButton.PNG" alt="Start">
        Start
      </div>
    
      <!-- Taskbar Buttons -->
      <div class="taskbar-buttons">
        <div *ngFor="let app of apps" class="taskbar-button" (click)="openWindow(app.component)">
          <img [src]="app.icon" alt="{{ app.name }}">
        </div>
      </div>
    
      <!-- System Tray -->
      <div class="system-tray">
        <div class="clock">{{ currentTime | date: 'shortTime' }}</div>
      </div>
    </div>
</div>

<div class="button-container" *ngIf="!windowsStarted && !videoStarted">
  <button class="video-button" (click)="startVideo()">Start</button><br><br><br>
</div>

<div class="video-container" *ngIf="!windowsStarted" (click)="resetWindows()">
  <video #videoPlayer playsinline webkit-playsinline muted loop>
    <source src="assets/MazeAnim.mp4" type="video/mp4">
    Your browser does not support the video tag.
  </video>
  <h2 *ngIf="videoStarted" class="text-overlay">Click anywhere to enter</h2>
</div>

